import clsx from "clsx";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { handleImageErrorProfile } from "../../../utils/UtilsFiles";

type Props = {
    selected: boolean;
    onSelect: () => void;
    avatars: string[];
    host?: boolean;
    section: string;
    previewContent: string;
    lastMessageAuthor?: string | null;
    lastMessage: string;
    createdAt: string;
    unreadCount?: number;
}

const classes: Record<number, string> = {
    1: 'single',
    2: 'couple',
    3: 'triple',
    4: 'quadruple'
}

export const MessageItem = ({ selected, onSelect, avatars, host, section, previewContent, lastMessage, lastMessageAuthor, createdAt, unreadCount = 0 }: Props) => {
    const formatMessageTime = (dateStr?: string) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        const today = new Date();
        if (date.toDateString() === today.toDateString()) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        }
        return date.toLocaleDateString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
    };

    const displayAvatars = avatars.length > 0 ? avatars : ["/media/avatars/150-2.jpg"];

    return (
        <div className={clsx("messages-page-item", { 'selected': selected })} onClick={onSelect}>
            <div className={clsx("avatars", classes[Math.min(displayAvatars.length, 4)] || 'single' )}>
                {displayAvatars.slice(0, 4).map((a, i) => 
                (
                    <div className="avatar-item" key={i}>
                        {i === 3 && displayAvatars.length > 4 && (
                            <div className="backdrop">
                                <span>+{displayAvatars.length - 3}</span>
                            </div>
                        )}
                        <img src={a.startsWith('http') ? a : toAbsoluteUrl(a)} onError={handleImageErrorProfile} />
                    </div>
                ))}
            </div>
            <div className="data">
                <div className="d-flex w-100 justify-content-between">
                    <div className="d-flex flex-row align-items-center" style={{ gap: '8px' }}>
                        {host && 
                            <div className="host">HOST</div>
                        }
                        <span className="min-text"> 
                            {section}
                        </span>
                    </div>
                    <span className="min-text">{formatMessageTime(createdAt)}</span>
                </div>
                <div className="d-flex w-100 justify-content-between align-items-center" style={{ gap: '5px' }}>
                    <span className={clsx('preview-content', 'nowrap-text', {'bold-text': unreadCount > 0})}>{previewContent}</span>
                    {unreadCount > 0 && (
                        <div className="unread-badge">
                            <span>{unreadCount}</span>
                        </div>
                    )}
                </div>
                <div className="d-flex w-100">
                    {lastMessageAuthor && 
                        <span className="nowrap-text min-text">{lastMessageAuthor} :&nbsp;</span>
                    }
                    <span className="nowrap-text preview-content">{lastMessage}</span>
                </div>
            </div>
        </div>
    )
}